import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const stylesRewardsAmounts = makeStyles(theme => ({
  redeemRewardBar: {
    color: themeColor.primaryColor,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `10px solid ${theme.palette.primary.main}`,
    width: '66px',
    margin: 'auto',
    marginTop: '5vh',
    marginBottom: '5vh',
    alignSelf: 'center',
  },
  redeemMarginTop: {
    marginTop: '2.5vh',
  },
  redeemMarginBottom: {
    marginBottom: '1.5vh',
  },
  redeemInfoText: {
    color: '#5D6B72',
  },
  icon: {
    marginRight: '0.5vw',
    color: theme.palette.secondary.main,
    fill: theme.palette.secondary.main,
    height: '2.34vh',
    width: 'auto',
  },
  redeemKeypadPadding: {
    paddingRight: '1.06vw',
    paddingBottom: '1.82vh',
  },
}));
